<header
  [class]="'bg-white/95 backdrop-blur-md z-50 fixed top-0 left-0 right-0 font-serif transition-all duration-500 ' + (isScrolled ? 'shadow-md border-b border-gray-100' : 'shadow-none border-b border-transparent')">
  <!-- Scroll Progress Bar -->
  <div *ngIf="scrollProgress > 0" class="scroll-progress" [ngStyle]="{'width': scrollProgress + '%'}"></div>
  <div class="px-2 sm:px-4 md:px-6 py-2 md:py-4">
    <div class="max-w-[1440px] mx-auto flex items-center justify-between gap-2 md:gap-10">

      <!-- Left: Logo + Hamburger -->
      <div class="flex items-center gap-2 md:gap-4 shrink-0">
        <!-- Mobile hamburger -->
        <button (click)="isMobileMenuOpen = !isMobileMenuOpen"
          class="lg:hidden p-2 hover:bg-rose-50 rounded-full text-gray-700 hover:text-[#600b0b] transition-all"
          aria-label="Toggle menu">
          <ng-container *ngIf="isMobileMenuOpen">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </ng-container>
          <ng-container *ngIf="!isMobileMenuOpen">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </ng-container>
        </button>

        <div (click)="router.navigate(['/'])"
          class="flex items-center cursor-pointer hover:opacity-90 transition-all select-none">
          <img src="https://storage.googleapis.com/mahattaart-wallpaper/logo%20(1).png" alt="Mahatta Art Logo"
            class="h-7 sm:h-9 md:h-11 w-auto object-contain" />
        </div>
      </div>

      <!-- Center Navigation - Desktop -->
      <nav class="hidden lg:flex items-center gap-8 xl:gap-12 shrink-0">
        <ng-container *ngFor="let item of navItems">
          <!-- Wall Art: toggle dropdown -->
          <button *ngIf="item.action === 'wall-art'" (click)="handleNavAction(item.action)"
            [class]="'wall-art-menu text-[15px] font-normal transition-colors whitespace-nowrap py-2 relative group flex items-center gap-1 ' + (wallArtMenuOpen ? 'text-[#600b0b]' : 'text-gray-700 hover:text-[#600b0b]')">
            {{ item.label }}
            <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 transition-transform"
              [class.rotate-180]="wallArtMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg> -->
            <span class="absolute bottom-0 left-0 h-[1px] bg-[#600b0b] transition-all duration-500"
              [class.w-full]="wallArtMenuOpen" [class.w-0]="!wallArtMenuOpen"></span>
          </button>
          <!-- Print & Frame: toggle dropdown -->
          <button *ngIf="item.action === 'print-frame'" (click)="handleNavAction(item.action)"
            [class]="'print-frame-menu text-[15px] font-normal transition-colors whitespace-nowrap py-2 relative group flex items-center gap-1 ' + (printFrameMenuOpen ? 'text-[#600b0b]' : 'text-gray-700 hover:text-[#600b0b]')">
            {{ item.label }}
            <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 transition-transform"
              [class.rotate-180]="printFrameMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg> -->
            <span class="absolute bottom-0 left-0 h-[1px] bg-[#600b0b] transition-all duration-500"
              [class.w-full]="printFrameMenuOpen" [class.w-0]="!printFrameMenuOpen"></span>
          </button>
          <!-- Other nav items -->
          <button *ngIf="item.action !== 'wall-art' && item.action !== 'print-frame'"
            (click)="handleNavAction(item.action)"
            [class]="'text-[15px] font-normal transition-colors whitespace-nowrap py-2 relative group ' + (item.highlight ? 'text-[#8B1216] font-semibold flex items-center gap-1.5' : 'text-gray-700 hover:text-[#600b0b]')">
            <!-- <svg *ngIf="item.highlight" xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2">
              <path
                d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
            </svg> -->
            {{ item.label }}
            <span
              class="absolute bottom-0 left-0 w-0 h-[1px] bg-[#600b0b] transition-all duration-500 group-hover:w-full"></span>
          </button>
        </ng-container>
      </nav>

      <!-- Right: Search + Actions -->
      <div class="flex items-center justify-end flex-grow gap-0.5 sm:gap-1 md:gap-3">
        <!-- Desktop Search (inline expand) -->
        <div class="hidden md:flex relative items-center transition-all duration-700 h-10"
          [class.flex-grow]="isSearchExpanded" [class.max-w-md]="isSearchExpanded" [class.w-10]="!isSearchExpanded">
          <div
            [class]="'absolute inset-0 flex items-center rounded-full border transition-all duration-500 ' + (isSearchExpanded ? 'px-5 opacity-100 border-gray-200 shadow-lg bg-white' : 'bg-transparent opacity-0 border-transparent pointer-events-none')">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 mr-3 shrink-0" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input #searchInput type="text" [(ngModel)]="searchQuery" placeholder="Search wallpapers, styles, rooms..."
              class="w-full bg-transparent border-none text-sm outline-none placeholder:text-gray-300 font-serif"
              (input)="searchWallpapersLive()" (keydown)="handleSearchKeydown($event)" />
            <button (click)="isSearchExpanded = false; searchQuery = ''"
              class="ml-2 p-1 hover:text-rose-900 transition-colors shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>
          <!-- Desktop Search Results -->
          <div *ngIf="isSearchExpanded && searchResults.length > 0"
            class="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 dropdown-enter">
            <button *ngFor="let wp of searchResults" (click)="navigateToSearchResult(wp.slug)"
              class="w-full flex items-center gap-3 px-4 py-3 hover:bg-rose-50/50 transition-colors text-left border-b border-gray-50 last:border-0">
              <img [src]="wp.hover_thumbnail || wp.list_thumbnail" [alt]="wp.name || wp.caption" class="w-10 h-10 rounded-lg object-cover shrink-0" />
              <div class="flex-1 min-w-0">
                <p class="text-sm font-serif font-medium text-gray-800 truncate">{{ wp.name || wp.caption }}</p>
                <p class="text-[9px] uppercase tracking-widest text-gray-400 font-bold">{{ wp.wallpaper_id || wp.title_slug }}</p>
              </div>
              <span *ngIf="searchResultPrice(wp) as rate" class="text-sm font-medium text-rose-900 shrink-0">&#8377;{{ rate | number:'1.0-2' }}</span>
            </button>
            <button (click)="
  router.navigate([searchListingPath], {
    queryParams: { searchtext: searchQuery }
  });
  isSearchExpanded = false;
  searchQuery = '';
" class="w-full py-2.5 text-[10px] font-bold uppercase tracking-[0.2em] text-[#600b0b] hover:bg-rose-50/50 transition-colors">
              View All Results
            </button>


          </div>
          <!-- Desktop: loading state (after Enter pressed) -->
          <div *ngIf="isSearchExpanded && isSearchLoading"
            class="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 dropdown-enter p-6 text-center">
            <div class="flex flex-col items-center gap-3">
              <div class="relative w-11 h-11">
                <div class="absolute inset-0 rounded-full border-2 border-rose-100"></div>
                <div class="absolute inset-0 rounded-full border-2 border-t-[#600b0b] animate-spin"></div>
                <div class="absolute inset-0 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                </div>
              </div>
              <div>
                <p class="text-sm font-serif text-gray-700">Searching<span class="animate-pulse">...</span></p>
                <p class="text-xs text-gray-400 mt-1 font-serif italic">"{{ searchQuery }}"</p>
              </div>
            </div>
          </div>
          <!-- Desktop: multi-word → press Enter prompt -->
          <div *ngIf="isSearchExpanded && !isSearchLoading && searchQuery.trim().length >= 2 && searchResults.length === 0 && isMultiWordSearch"
            class="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 dropdown-enter p-6 text-center">
            <div class="flex flex-col items-center gap-3">
              <div class="w-11 h-11 rounded-full bg-rose-50 flex items-center justify-center animate-pulse">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </div>
              <div>
                <p class="text-sm font-serif text-gray-700">Press <kbd class="px-1.5 py-0.5 text-xs font-mono bg-gray-100 rounded border border-gray-200 text-gray-600">Enter</kbd> to search</p>
                <p class="text-xs text-gray-400 mt-1 font-serif italic">"{{ searchQuery }}"</p>
              </div>
            </div>
          </div>
          <!-- Desktop: single-word + no results -->
          <div *ngIf="isSearchExpanded && searchQuery.trim().length >= 2 && searchResults.length === 0 && !isMultiWordSearch"
            class="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 dropdown-enter p-6 text-center">
            <p class="text-sm text-gray-400 font-serif">No results for "{{ searchQuery }}"</p>
            <button (click)="router.navigate([searchListingPath]); isSearchExpanded = false; searchQuery = ''"
              class="mt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-[#600b0b] hover:underline">Browse All
              Designs</button>
          </div>
          <button *ngIf="!isSearchExpanded" (click)="onSearchBarClick('header')"
            class="w-10 h-10 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:bg-rose-50 rounded-full transition-all shrink-0"
            aria-label="Search">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </div>

        <!-- Mobile Search Icon -->
        <button (click)="isSearchExpanded ? isSearchExpanded = false : onSearchBarClick('mobile')"
          class="md:hidden w-9 h-9 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:bg-rose-50 rounded-full transition-all shrink-0"
          aria-label="Search">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[18px] h-[18px]" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </button>

        <!-- Wishlist -->
        <button (click)="router.navigate(['/wishlist'])"
          class="relative w-9 h-9 md:w-10 md:h-10 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:bg-rose-50 rounded-full transition-all"
          aria-label="Wishlist">
          <svg xmlns="http://www.w3.org/2000/svg"
            [class]="'w-[18px] h-[18px] md:w-5 md:h-5 ' + (wishlistCount > 0 ? 'fill-[#600b0b] text-[#600b0b]' : '')"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
          </svg>
          <span *ngIf="wishlistCount > 0"
            class="absolute top-1 right-1 bg-[#600b0b] text-white text-[9px] font-bold min-w-[16px] h-[16px] flex items-center justify-center rounded-full border-2 border-white shadow count-pop">{{
            wishlistCount }}</span>
        </button>

        <!-- Cart with Mini Cart Preview -->
        <div class="relative" (mouseenter)="handleMiniCartEnter()" (mouseleave)="handleMiniCartLeave()">
          <button (click)="router.navigate(['/checkout'])"
            class="relative w-9 h-9 md:w-10 md:h-10 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:bg-rose-50 rounded-full transition-all"
            aria-label="Shopping Cart">
            <svg xmlns="http://www.w3.org/2000/svg"
              [class]="'w-[18px] h-[18px] md:w-5 md:h-5 ' + (cartCount > 0 ? 'text-[#600b0b]' : '')" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            <span *ngIf="cartCount > 0"
              class="absolute top-1 right-1 bg-[#600b0b] text-white text-[9px] font-bold min-w-[16px] h-[16px] flex items-center justify-center rounded-full border-2 border-white shadow count-pop">{{
              cartCount }}</span>
          </button>

          <!-- Mini Cart Dropdown -->
          <div *ngIf="showMiniCart && cartItems.length > 0"
            class="absolute top-full right-0 mt-2 w-[320px] bg-white rounded-xl shadow-2xl border border-gray-100 z-50 minicart-enter overflow-hidden">
            <div class="px-4 py-3 border-b border-gray-100 flex items-center justify-between">
              <span class="text-[10px] font-bold uppercase tracking-[0.15em] text-gray-500">Cart ({{ cartCount
                }})</span>
              <div class="flex items-center gap-2">
                <span class="text-sm font-medium text-rose-900">&#8377;{{ cartSubtotal | number:'1.0-2' }}</span>
                <button (click)="showMiniCart = false" class="text-gray-400 hover:text-rose-700 transition-colors p-0.5 rounded hover:bg-rose-50">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="max-h-[240px] overflow-y-auto">
              <div *ngFor="let item of cartItems.slice(0, 3)"
                class="relative flex items-center gap-3 px-4 py-3 border-b border-gray-50 hover:bg-rose-50/30 transition-colors group">
                <img [src]="item.image" [alt]="item.name"
                  class="w-12 h-12 rounded-lg object-cover shrink-0 cursor-pointer" (click)="navigateToCartItem(item)" />
                <div class="flex-1 min-w-0 pr-6">
                  <p class="text-sm font-serif font-medium text-gray-800 truncate">{{ item.name }}</p>
                  <p class="text-[9px] text-gray-400">Qty: {{ item.quantity }} &bull; &#8377;{{ item.price | number:'1.0-2' }}</p>
                </div>
                <button (click)="removeFromCart(item)"
                  class="absolute top-2 right-3 text-gray-400 hover:text-rose-700 transition-colors p-1 rounded hover:bg-rose-50">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                </button>
              </div>
              <p *ngIf="cartItems.length > 3" class="text-center py-2 text-[9px] text-gray-400">+{{
                cartItems.length - 3 }} more items</p>
            </div>
            <div class="px-4 py-3 bg-rose-50/30">
              <button (click)="router.navigate(['/checkout']); showMiniCart = false"
                class="w-full bg-rose-900 text-white py-2.5 rounded-lg font-bold uppercase tracking-[0.15em] text-[10px] hover:bg-rose-800 transition-all active:scale-[0.98]">
                View Cart & Checkout
              </button>
            </div>
          </div>
        </div>

        <div class="hidden sm:block w-px h-7 bg-gray-200 mx-1"></div>

        <!-- User: Not logged in -->
        <button *ngIf="!currentUser" (click)="openAuthModal()"
          class="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center text-gray-600 hover:text-[#600b0b] hover:bg-rose-50 rounded-full transition-all"
          aria-label="Account">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-[18px] h-[18px] md:w-5 md:h-5" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </button>

        <!-- User: Logged in - Account dropdown -->
        <div *ngIf="currentUser" class="relative account-menu">
          <button (click)="toggleAccountMenu()"
            class="flex items-center gap-1.5 text-gray-600 hover:text-[#600b0b] transition-all px-1.5 py-1 rounded-full hover:bg-rose-50">
            <div class="w-8 h-8 md:w-9 md:h-9 rounded-full bg-gray-200 flex items-center justify-center shrink-0">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 md:w-5 md:h-5 text-gray-500" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <span class="hidden md:inline text-xs font-semibold text-[#600b0b] max-w-[80px] truncate">{{
              currentUser.name }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-gray-400 hidden md:block" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2.5">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>

          <!-- Account Dropdown -->
          <div *ngIf="showAccountMenu"
            class="absolute top-full right-0 mt-2 w-[220px] bg-white rounded-xl shadow-2xl border border-gray-100 z-50 overflow-hidden dropdown-enter"
            style="font-family: sans-serif;">
            <!-- User info -->
            <div class="flex items-center gap-3 px-4 py-3 border-b border-gray-100">
              <div class="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-500" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </div>
              <div class="min-w-0">
                <p class="text-sm font-semibold text-gray-800 truncate" style="font-family: 'Roboto Slab', serif;">{{
                  currentUser.name }}</p>
                <p class="text-[10px] text-gray-400 truncate">{{ currentUser.email }}</p>
              </div>
            </div>

            <!-- Menu items -->
            <div class="py-1">
              <button (click)="showAccountMenu = false; router.navigate(['/account'])"
                class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors text-left">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="3" />
                  <path
                    d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
                </svg>
                ACCOUNT SETTINGS
              </button>
              <button (click)="showAccountMenu = false; router.navigate(['/account/orders'])"
                class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors text-left">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                </svg>
                ORDER HISTORY
              </button>
              <button (click)="showAccountMenu = false; router.navigate(['/faq'])"
                class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors text-left">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
                HELP
              </button>
            </div>

            <!-- Sign out -->
            <div class="border-t border-gray-100">
              <button (click)="logout()"
                class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors text-left">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                  <polyline points="16 17 21 12 16 7" />
                  <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
                SIGN OUT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Search Bar (below navbar) -->
  <div *ngIf="isSearchExpanded" class="md:hidden border-t border-gray-100 px-3 py-2.5 bg-white">
    <div class="relative">
      <div class="flex items-center bg-gray-50 rounded-full border border-gray-200 px-4 h-10">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 mr-2 shrink-0" viewBox="0 0 24 24"
          fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input type="text" [(ngModel)]="searchQuery" placeholder="Search wallpapers..."
          class="w-full bg-transparent border-none text-sm outline-none placeholder:text-gray-400 font-serif"
          (keyup)="searchWallpapersLive()" (keydown)="handleSearchKeydown($event)" />
        <button (click)="isSearchExpanded = false; searchQuery = ''"
          class="ml-2 p-1 text-gray-400 hover:text-rose-900 transition-colors shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <!-- Mobile Search Results -->
      <div *ngIf="searchResults.length > 0"
        class="absolute top-full left-0 right-0 mt-1.5 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 max-h-[60vh] overflow-y-auto">
        <button *ngFor="let wp of searchResults" (click)="navigateToSearchResult(wp.slug)"
          class="w-full flex items-center gap-3 px-4 py-3 hover:bg-rose-50/50 transition-colors text-left border-b border-gray-50 last:border-0">
          <img [src]="wp.hover_thumbnail || wp.list_thumbnail" [alt]="wp.name || wp.caption" class="w-10 h-10 rounded-lg object-cover shrink-0" />
          <div class="flex-1 min-w-0">
            <p class="text-sm font-serif font-medium text-gray-800 truncate">{{ wp.name || wp.caption }}</p>
            <p class="text-[9px] uppercase tracking-widest text-gray-400 font-bold">{{ wp.wallpaper_id || wp.title_slug }}</p>
          </div>
          <span *ngIf="searchResultPrice(wp) as rate" class="text-sm font-medium text-rose-900 shrink-0">&#8377;{{ rate | number:'1.0-2' }}</span>
        </button>
        <button
          (click)="state.updateContext({search_query: searchQuery, selected_space: null, selected_category: null, selected_mood: null, entry_point: null}); router.navigate([searchListingPath], { queryParams: { searchtext: searchQuery } }); isSearchExpanded = false; searchQuery = ''"
          class="w-full py-2.5 text-[10px] font-bold uppercase tracking-[0.2em] text-[#600b0b] hover:bg-rose-50/50 transition-colors">
          View All Results
        </button>
      </div>
      <!-- Mobile: loading state (after Enter pressed) -->
      <div *ngIf="isSearchLoading"
        class="absolute top-full left-0 right-0 mt-1.5 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 p-5 text-center">
        <div class="flex flex-col items-center gap-2.5">
          <div class="relative w-10 h-10">
            <div class="absolute inset-0 rounded-full border-2 border-rose-100"></div>
            <div class="absolute inset-0 rounded-full border-2 border-t-[#600b0b] animate-spin"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
            </div>
          </div>
          <div>
            <p class="text-sm font-serif text-gray-700">Searching<span class="animate-pulse">...</span></p>
            <p class="text-xs text-gray-400 mt-1 font-serif italic">"{{ searchQuery }}"</p>
          </div>
        </div>
      </div>
      <!-- Mobile: multi-word → press Enter prompt -->
      <div *ngIf="!isSearchLoading && searchQuery.trim().length >= 2 && searchResults.length === 0 && isMultiWordSearch"
        class="absolute top-full left-0 right-0 mt-1.5 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 p-5 text-center">
        <div class="flex flex-col items-center gap-2.5">
          <div class="w-10 h-10 rounded-full bg-rose-50 flex items-center justify-center animate-pulse">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-[#600b0b]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <div>
            <p class="text-sm font-serif text-gray-700">Press <kbd class="px-1.5 py-0.5 text-xs font-mono bg-gray-100 rounded border border-gray-200 text-gray-600">Enter</kbd> to search</p>
            <p class="text-xs text-gray-400 mt-1 font-serif italic">"{{ searchQuery }}"</p>
          </div>
        </div>
      </div>
      <!-- Mobile: single-word + no results -->
      <div *ngIf="searchQuery.trim().length >= 2 && searchResults.length === 0 && !isMultiWordSearch"
        class="absolute top-full left-0 right-0 mt-1.5 bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden z-50 p-5 text-center">
        <p class="text-sm text-gray-400 font-serif">No results for "{{ searchQuery }}"</p>
        <button (click)="router.navigate([searchListingPath]); isSearchExpanded = false; searchQuery = ''"
          class="mt-2 text-[10px] font-bold uppercase tracking-[0.2em] text-[#600b0b] hover:underline">Browse All
          Designs</button>
      </div>
    </div>
  </div>
</header>
<!-- Spacer to prevent content from hiding behind fixed header -->
<div class="h-[48px] md:h-[68px]"></div>

<!-- Wall Art Submenu Bar -->
<div *ngIf="wallArtMenuOpen" class="wall-art-menu bg-white border-b border-gray-200 shadow-md z-40 sticky top-[61px]">
  <div class="max-w-[1440px] mx-auto px-6 py-2 flex items-center justify-center gap-8">

    <!-- Shop By Category -->
    <div class="relative">
      <button (click)="shopByCategoryOpen = !shopByCategoryOpen; $event.stopPropagation()"
        class="flex items-center gap-1.5 text-sm font-bold text-gray-700 hover:text-[#600b0b] py-2 transition-colors uppercase tracking-wider">
        Shop By Category
        <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 transition-transform"
          [class.rotate-180]="shopByCategoryOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg> -->
      </button>

      <!-- Categories Dropdown -->
      <div *ngIf="shopByCategoryOpen"
        class="absolute top-full left-0 mt-1 w-[420px] bg-white rounded-xl shadow-2xl border border-gray-100 z-50 py-4">

        <div class="grid grid-cols-2 gap-y-2">

          <button *ngFor="let cat of topCategories" (click)="navigateToCategory(cat)"
            class="text-left px-5 py-2 text-sm font-serif text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors flex items-center justify-between group">

            <span>{{ cat.title || cat.name }}</span>

            <svg xmlns="http://www.w3.org/2000/svg"
              class="w-3.5 h-3.5 text-gray-300 group-hover:text-[#600b0b] opacity-0 group-hover:opacity-100 transition-all"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>

          </button>

        </div>

        <div *ngIf="categories.length === 0" class="px-5 py-3 text-sm text-gray-400">
          Loading categories...
        </div>

      </div>
    </div>

    <!-- Divider -->
    <div class="w-px h-5 bg-gray-200"></div>

    <!-- ArtReady -->
    <button (click)="navigateToArtReady()"
      class="text-sm font-bold text-gray-700 hover:text-[#600b0b] py-2 uppercase tracking-wider transition-colors flex items-center gap-1.5">
      ArtReady
      <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
      </svg> -->
    </button>
  </div>
</div>

<!-- Print & Frame Submenu Bar -->
<div *ngIf="printFrameMenuOpen"
  class="print-frame-menu bg-white border-b border-gray-200 shadow-md z-40 sticky top-[61px]">
  <div class="max-w-[1440px] mx-auto px-6 py-2 flex items-center justify-center gap-8">

    <!-- Frame Your Photos (with sub-dropdown) -->
    <div class="relative">
      <button (click)="frameYourPhotosOpen = !frameYourPhotosOpen; $event.stopPropagation()"
        class="flex items-center gap-1.5 text-sm font-bold text-gray-700 hover:text-[#600b0b] py-2 transition-colors uppercase tracking-wider">
        Frame Your Photos
        <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 transition-transform"
          [class.rotate-180]="frameYourPhotosOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2.5">
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg> -->
      </button>
      <div *ngIf="frameYourPhotosOpen"
        class="absolute top-full left-0 mt-1 w-[200px] bg-white rounded-xl shadow-2xl border border-gray-100 z-50 py-2">
        <button *ngFor="let sub of printFrameSubItems" (click)="navigateToPrintFrame(sub.path, sub.queryParams)"
          class="w-full text-left px-5 py-2.5 text-sm font-serif text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors flex items-center justify-between group">
          <span>{{ sub.label }}</span>
          <svg xmlns="http://www.w3.org/2000/svg"
            class="w-3.5 h-3.5 text-gray-300 opacity-0 group-hover:opacity-100 group-hover:text-[#600b0b] transition-all"
            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
      </div>
    </div>

    <div class="w-px h-5 bg-gray-200"></div>

    <!-- Collage Set -->
    <button (click)="navigateToPrintFrame('/print-frame/collage-set')"
      class="text-sm font-bold text-gray-700 hover:text-[#600b0b] py-2 uppercase tracking-wider transition-colors">
      Collage Set
    </button>

    <div class="w-px h-5 bg-gray-200"></div>

    <!-- Featured Frames -->
    <button (click)="navigateToPrintFrame('/print-frame/featured-frames')"
      class="text-sm font-bold text-gray-700 hover:text-[#600b0b] py-2 uppercase tracking-wider transition-colors flex items-center gap-1.5">
      Featured Frames
      <!-- <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2">
        <polygon
          points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
        </polygon>
      </svg> -->
    </button>
  </div>
</div>

<!-- Auth Modal Component -->
<app-auth-modal #authModal [isOpen]="isAuthModalOpen" (closeModal)="closeAuthModal()"></app-auth-modal>

<!-- Mobile Menu Overlay -->
<div
  [class]="'fixed inset-0 z-40 transition-all duration-500 lg:hidden ' + (isMobileMenuOpen ? 'visible' : 'invisible')">
  <div
    [class]="'absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity duration-500 ' + (isMobileMenuOpen ? 'opacity-100' : 'opacity-0')"
    (click)="isMobileMenuOpen = false"></div>
  <div
    [class]="'absolute left-0 top-0 h-full w-[300px] max-w-[80vw] bg-white shadow-2xl transition-transform duration-500 ease-out ' + (isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full')">
    <div class="p-6 border-b border-gray-100">
      <img src="https://storage.googleapis.com/mahattaart-wallpaper/logo%20(1).png" alt="Mahatta Art"
        class="h-10 w-auto" />
    </div>
    <nav class="py-4">
      <ng-container *ngFor="let item of navItems">
        <!-- Wall Art with expandable sub-items -->
        <div *ngIf="item.action === 'wall-art'" class="wall-art-menu">
          <button (click)="toggleMobileSubmenu(item.action); $event.stopPropagation()"
            class="w-full flex items-center justify-between px-6 py-4 text-left transition-all font-serif text-lg text-gray-800 hover:bg-rose-50 hover:text-[#600b0b]">
            <span>{{ item.label }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 transition-transform"
              [class.rotate-180]="wallArtMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <!-- Mobile sub-items -->
          <div *ngIf="wallArtMenuOpen" class="bg-gray-50 border-t border-gray-100">
            <!-- Shop By Category expandable -->
            <button (click)="shopByCategoryOpen = !shopByCategoryOpen; $event.stopPropagation()"
              class="w-full flex items-center justify-between px-8 py-3 text-left text-sm font-bold uppercase tracking-wider text-gray-600 hover:text-[#600b0b] transition-colors">
              <span>Shop By Category</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 transition-transform"
                [class.rotate-180]="shopByCategoryOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            <div *ngIf="shopByCategoryOpen" class="bg-white border-t border-gray-100 max-h-[260px] overflow-y-auto">
              <button *ngFor="let cat of topCategories" (click)="navigateToCategory(cat)"
                class="w-full text-left px-10 py-2.5 text-sm font-serif text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors">
                {{ cat.title || cat.name }}
              </button>
            </div>
            <!-- ArtReady -->
            <button (click)="navigateToArtReady()"
              class="w-full flex items-center justify-between px-8 py-3 text-left text-sm font-bold uppercase tracking-wider text-gray-600 hover:text-[#600b0b] transition-colors border-t border-gray-100">
              <span>ArtReady</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-300" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
        </div>
        <!-- Print & Frame with expandable sub-items -->
        <div *ngIf="item.action === 'print-frame'" class="print-frame-menu">
          <button (click)="toggleMobileSubmenu(item.action); $event.stopPropagation()"
            class="w-full flex items-center justify-between px-6 py-4 text-left transition-all font-serif text-lg text-gray-800 hover:bg-rose-50 hover:text-[#600b0b]">
            <span>{{ item.label }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 transition-transform"
              [class.rotate-180]="printFrameMenuOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2">
              <polyline points="6 9 12 15 18 9" />
            </svg>
          </button>
          <div *ngIf="printFrameMenuOpen" class="bg-gray-50 border-t border-gray-100">
            <button (click)="frameYourPhotosOpen = !frameYourPhotosOpen; $event.stopPropagation()"
              class="w-full flex items-center justify-between px-8 py-3 text-left text-sm font-bold uppercase tracking-wider text-gray-600 hover:text-[#600b0b] transition-colors">
              <span>Frame Your Photos</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 transition-transform"
                [class.rotate-180]="frameYourPhotosOpen" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2">
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </button>
            <div *ngIf="frameYourPhotosOpen" class="bg-white border-t border-gray-100">
              <button *ngFor="let sub of printFrameSubItems" (click)="navigateToPrintFrame(sub.path, sub.queryParams)"
                class="w-full text-left px-12 py-2.5 text-sm font-serif text-gray-700 hover:bg-rose-50 hover:text-[#600b0b] transition-colors">
                {{ sub.label }}
              </button>
            </div>
            <button (click)="navigateToPrintFrame('/print-frame/collage-set')"
              class="w-full flex items-center justify-between px-8 py-3 text-left text-sm font-bold uppercase tracking-wider text-gray-600 hover:text-[#600b0b] transition-colors border-t border-gray-100">
              <span>Collage Set</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-300" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
            <button (click)="navigateToPrintFrame('/print-frame/featured-frames')"
              class="w-full flex items-center justify-between px-8 py-3 text-left text-sm font-bold uppercase tracking-wider text-gray-600 hover:text-[#600b0b] transition-colors border-t border-gray-100">
              <span>Featured Frames</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-gray-300" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
        </div>
        <!-- Other nav items -->
        <button *ngIf="item.action !== 'wall-art' && item.action !== 'print-frame'"
          (click)="handleNavAction(item.action)"
          [class]="'w-full flex items-center justify-between px-6 py-4 text-left transition-all font-serif text-lg ' + (item.highlight ? 'text-[#8B1216] font-semibold bg-red-50/50' : 'text-gray-800 hover:bg-rose-50 hover:text-[#600b0b]')">
          <span class="flex items-center gap-2">
            <svg *ngIf="item.highlight" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2">
              <path
                d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
            </svg>
            {{ item.label }}
          </span>
          <!-- No chevron here: these items navigate straight away and have no
               submenu, so an arrow would suggest an expandable section. -->
        </button>
      </ng-container>
    </nav>
  </div>
</div>